import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function GamesStatus() {
  let navigate = useNavigate();
  const [games, setGames] = useState([]);
  useEffect(() => {
    axios
      .get("https://verbalvortex-server.onrender.com/games/games-status", {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        setGames(response.data);
      });
  }, []);

  const playGame = (gameId) => {
    navigate(`/game/${gameId}`);
    axios.put(
      "https://verbalvortex-server.onrender.com/games/turnsTaken",
      {
        gameId: gameId,
      },
      {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      }
    );
  };

  return (
    <div className="GamesStatus">
      <div id="GamesStatus__title">GAMES STATUS</div>
      <hr />
      <div id="GamesStatus__statuses">
        {games.map((game) => (
          <div id="GamesStatus__status">
            <div key={game.Game.gameId}>
              <div>Game Status: <p id="GamesStatus__CurrentStatus">{game.Game.status}</p></div>
              <div id="GamesStatus__Usernames">Users in Game:</div>
              <ul>
                {game.UsersInGame.map((user) => (
                  <li key={user.id}>{user.username}</li>
                ))}
              </ul>
              {game.turnsTaken < 10 && (
                <button id="GamesStatus__PlayButton" onClick={() => playGame(game.Game.gameId)}>Play Game</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default GamesStatus;
